<template>
  <div>
    <div
      style="
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 999;
        background-color: #ffffff;
      "
    >
      <div
        style="
          margin: 0 auto;
          padding: 0 20px;
          width: 1200px;
          height: 80px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <el-image
          :src="require('@/assets/logo.png')"
          style="width: 272px; height: 55px"
        ></el-image>
        <div
          style="
            margin-left: 180px;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            background-color: #ffffff;
            /* '#27cbee' */
          "
        >
          <div :class="['menu-item']" @click="handleClick('about')">
            关于我们
          </div>
          <div :class="['menu-item']" @click="handleClick('trend')">
            行业动态
          </div>
          <div :class="['menu-item']" @click="handleClick('news')">
            新闻公告
          </div>
          <div :class="['menu-item']" @click="handleClick('center')">
            健康中心
          </div>
          <div :class="['menu-item']" @click="handleClick('contact')">
            联系我们
          </div>
        </div>
      </div>
    </div>
    <el-carousel style="margin-top: 80px; width: 100%" height="460px">
      <el-carousel-item v-for="item in imageList" :key="item">
        <el-image style="width: 100%;" :src="item" fit="cover"></el-image>
      </el-carousel-item>
    </el-carousel>
    <div
      id="about"
      style="
        display: flex;
        align-items: flex-start;
        width: 1200px;
        margin: 80px auto 120px auto;
        padding: 0 20px;
        box-sizing: border-box;
        background-color: #ffffff;
      "
    >
      <div style="margin-right: 20px">
        <div style="margin-bottom: 40px; font-size: 24px; color: #5c5c5c">
          关于我们
        </div>
        <div
          style="
            padding: 0;
            margin: 0;
            color: #999999;
            font-size: 13px;
            font-weight: normal;
            font-style: normal;
            text-decoration: none;
            text-align: left;
            line-height: 33px;
            word-wrap: break-word;
            word-break: normal;
          "
        >
          正心大药房2003年10月28日开始筹建，2004年2月21日正式对外营业。是宝坻区开架自选与柜台销售相结合的药店，药品率先通过了国家药品监督管理局的GSP认证，经营药品严格管理分类存放，商品实行统一条形码登记，微机化管理。<br />
          药品保存建立恒温湿库，建立一个标准化的配送调度中心。各门店使用的进、销、存系统全部基于广域网，实行客户端连接服务器的流程，适时了解各门店的销售及库存，严格的保证药品质量，让顾客买上合格药品，同时也得到了广大顾客的一致好评。<br />
          在销售上全部采用现代化的计算机操作系统。经营范围涵盖：西药、中药、保健品、保健食品、医疗器械、计生用品、日化用品等，品种近4000余种。100%正品，100%信赖，我们用心，只为您买的放心！<br />相信十几年的老品牌，相信14万会员的信赖选择！
        </div>
      </div>
      <el-image
        :src="require('@/assets/about.jpg')"
        style="width: 351px; height: 233px; flex-shrink: 0"
      ></el-image>
    </div>
    <div
      id="trend"
      style="
        background-color: #f5f5f5;
        text-align: center;
        padding: 60px 0 160px 0;
      "
    >
      <div style="font-size: 24px; color: #5c5c5c">行业动态</div>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 1200px;
          margin: 80px auto 0 auto;
          padding: 0 80px;
          box-sizing: border-box;
        "
      >
        <el-card
          shadow="hover"
          style="width: 240px; height: 354px; cursor: pointer"
          :body-style="{ padding: '0px' }"
          @click.native="handleToDetail(1, 1)"
        >
          <el-image
            :src="require('@/assets/card-1.png')"
            fit="contain"
            style="width: 240px; height: 160px"
          />
          <div
            style="
              padding: 14px;
              text-align: center;
              font-size: 14px;
              color: #333333;
            "
          >
            <span>新零售时代来临 医药行业发展趋势</span>
          </div>
          <div
            style="
              padding: 14px;
              text-align: left;
              font-size: 12px;
              color: #aaaaaa;
            "
          >
            <span
              >2017年中医药电商基础服务体系会更加完善。电商平台建立、移动互联网成熟、配送等服务体系不断完善，医药电商将成为新兴购药渠道。</span
            >
          </div>
        </el-card>
        <el-card
          shadow="hover"
          style="width: 240px; height: 354px; cursor: pointer"
          :body-style="{ padding: '0px' }"
          @click.native="handleToDetail(2, 1)"
        >
          <el-image
            :src="require('@/assets/card-2.png')"
            fit="contain"
            style="width: 240px; height: 160px"
          />
          <div
            style="
              padding: 14px;
              text-align: center;
              font-size: 14px;
              color: #333333;
            "
          >
            <span>连锁药店市场再遇瓶颈 医药电商成为连锁药店救命稻草</span>
          </div>
          <div
            style="
              padding: 14px;
              text-align: left;
              font-size: 12px;
              color: #aaaaaa;
            "
          >
            <span
              >随着“药价放开”政策的执行，药品价格由市场自由竞争来决定，大量消费者可以选择在院外购药，这对药店来说是利好的。</span
            >
          </div>
        </el-card>
        <el-card
          shadow="hover"
          style="width: 240px; height: 354px; cursor: pointer"
          :body-style="{ padding: '0px' }"
          @click.native="handleToDetail(3, 1)"
        >
          <el-image
            :src="require('@/assets/card-3.png')"
            fit="contain"
            style="width: 240px; height: 160px"
          />
          <div
            style="
              padding: 14px;
              text-align: center;
              font-size: 14px;
              color: #333333;
            "
          >
            <span>全国统一医保平台上线 影响39万药店</span>
          </div>
          <div
            style="
              padding: 14px;
              text-align: left;
              font-size: 12px;
              color: #aaaaaa;
            "
          >
            <span>国家医保信息平台要来了，至少39万家定点药店受益</span>
          </div>
        </el-card>
      </div>
    </div>
    <div
      id="news"
      style="
        display: flex;
        align-items: flex-start;
        width: 1200px;
        margin: 80px auto 120px auto;
        padding: 0 20px;
        box-sizing: border-box;
        background-color: #ffffff;
      "
    >
      <div
        style="
          font-size: 24px;
          color: #5c5c5c;
          margin-right: 150px;
          flex-shrink: 0;
        "
      >
        新闻公告
      </div>
      <div style="flex: 1">
        <div
          v-for="(item, index) in newsData"
          :key="index"
          style="
            cursor: pointer;
            display: flex;
            align-items: flex-start;
            padding-bottom: 15px;
            margin-bottom: 15px;
            border-bottom: 1px solid #ddd;
          "
          @click="handleToDetail(index + 1, 2)"
        >
          <el-image
            :src="item.imgUrl"
            fit="contain"
            style="
              width: 116px;
              height: 88px;
              flex-shrink: 0;
              margin-right: 10px;
            "
          ></el-image>
          <div>
            <div style="font-size: 14px; line-height: 24px; color: #404040">
              {{ item.title }}
            </div>
            <div
              style="
                margin-top: 5px;
                font-size: 12px;
                line-height: 18px;
                color: #999;
                text-decoration: none;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                word-break: break-all;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ item.content }}
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 10px;
                font-size: 12px;
                line-height: 20px;
                color: #bbb;
              "
            >
              <div>
                {{ item.date }}
              </div>
              <div style="display: flex; align-items: baseline">
                <i class="el-icon-view"></i>
                <span>{{ item.viewNum }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="center"
      style="
        background-color: #f5f5f5;
        text-align: center;
        padding: 60px 0 160px 0;
      "
    >
      <div style="font-size: 24px; color: #5c5c5c">健康中心</div>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 1200px;
          margin: 80px auto 0 auto;
          padding: 0 80px;
          box-sizing: border-box;
        "
      >
        <el-card
          v-for="(item, index) in tipsData"
          :key="index"
          shadow="hover"
          style="width: 316px; height: 250px; cursor: pointer"
          :body-style="{ padding: '20px' }"
          @click.native="handleToDetail(index + 1, 3)"
        >
          <div
            style="
              margin-bottom: 30px;
              text-align: center;
              font-size: 14px;
              color: #333333;
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <el-image
              :src="item.imgUrl"
              fit="contain"
              style="
                width: 88px;
                height: 88px;
                flex-shrink: 0;
                margin-right: 10px;
              "
            />
            <span>{{ item.title }}</span>
          </div>
          <div style="text-align: left; font-size: 12px; color: #aaaaaa">
            <span>{{ item.content }}</span>
          </div>
        </el-card>
      </div>
    </div>
    <div
      id="contact"
      style="
        width: 1200px;
        margin: 80px auto 120px auto;
        padding: 0 20px;
        box-sizing: border-box;
        background-color: #ffffff;
      "
    >
      <div
        style="
          margin-bottom: 80px;
          font-size: 24px;
          color: #5c5c5c;
          margin-right: 150px;
          flex-shrink: 0;
        "
      >
        联系我们
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          line-height: 18px;
          color: #666;
        "
      >
        <el-image
          :src="require('@/assets/address.png')"
          fit="contain"
          style="
            width: 458px;
            height: 314px;
            flex-shrink: 0;
            margin-right: 30px;
          "
        />
        <div>
          <div
            style="display: flex; align-items: baseline; margin-bottom: 10px"
          >
            <i style="margin-right: 10px" class="el-icon-office-building"></i>
            <span>药店名称：天津市正心大药房连锁有限公司</span>
          </div>
          <div
            style="display: flex; align-items: baseline; margin-bottom: 10px"
          >
            <i style="margin-right: 10px" class="el-icon-phone-outline"></i>
            <span>咨询电话：022-29229912</span>
          </div>
          <div
            style="display: flex; align-items: baseline; margin-bottom: 10px"
          >
            <i style="margin-right: 10px" class="el-icon-printer"></i>
            <span>投诉电话：022-29239913</span>
          </div>
          <div
            style="display: flex; align-items: baseline; margin-bottom: 10px"
          >
            <i style="margin-right: 10px" class="el-icon-location-outline"></i>
            <span>地址：天津市宝坻区津围公路10号</span>
          </div>
          <div
            style="display: flex; align-items: baseline; margin-bottom: 10px"
          >
            <i style="margin-right: 10px" class="el-icon-link"></i>
            <span
              >互联网药品信息服务资格证书编号：（津）—非经营性—2021—0051</span
            >
          </div>
          <div
            style="display: flex; align-items: baseline; margin-bottom: 10px"
          >
            <el-form
              ref="form"
              style="width: 80%"
              :model="form"
              :rules="rules"
              label-width="0"
            >
              <el-form-item label="" prop="title">
                <el-input
                  v-model="form.title"
                  placeholder="留言标题"
                ></el-input>
              </el-form-item>
              <el-form-item label="" prop="content">
                <el-input
                  v-model="form.content"
                  placeholder="留言内容"
                ></el-input>
              </el-form-item>
              <el-form-item label="" prop="email">
                <el-input
                  v-model="form.email"
                  placeholder="留言邮箱"
                ></el-input>
              </el-form-item>
              <el-form-item label="" prop="code">
                <div style="display: flex; align-items: center">
                  <el-input v-model="form.code" placeholder="验证码">
                  </el-input>
                  <canvas
                    ref="captchaCanvas"
                    width="120"
                    height="36"
                    class="captcha"
                    @click="refreshCaptcha"
                  ></canvas>
                </div>
              </el-form-item>
              <el-button
                type="primary"
                style="background-color: #ca211e; border: 1px solid #ca211e"
                @click="handleSubmit"
                >提交</el-button
              >
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div
      style="
        padding: 20px 0;
        background-color: rgb(238, 238, 238);
        text-align: center;
        font-size: 14px;
        line-height: 20px;
        color: #434a54;
      "
    >
      版权所有： 天津市正心大药房连锁有限公司
    </div>
    <div
      style="
        padding: 20px 0;
        text-align: center;
        font-size: 12px;
        line-height: 20px;
        color: rgb(152, 152, 152);
      "
    >
      津ICP备16004233号-1
    </div>
  </div>
</template>

<script>
export default {
  data() {
    let checkCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请填写验证码"));
      }
      // 验证value和验证码是否一致，不区分大小写
      else if (value.toUpperCase() != this.captchaCode.toUpperCase()) {
        callback(new Error("验证码错误"));
      } else {
        callback();
      }
    };
    return {
      imageList: [
        require("@/assets/scroll-image-1.png"),
        require("@/assets/scroll-image-2.png"),
      ],
      newsData: [
        {
          imgUrl: require("@/assets/news-1.jpeg"),
          title:
            "门店功能分区，店面升级改造即，我们将以更好的服务环境和精神面貌为您服务",
          content:
            "正心大药房，从2003年10月建店至今，已经陪伴大家18年之久，风霜雕刻，时过境迁，现在的我们也已经被时光剥去了初见的光鲜亮丽，剩下斑驳的墙衣与朦胧的玻璃镌刻下我们一起走过的痕迹，而我们的初心，却一直没变。保证产品品质，满足客户需求提供卓越服务，是我们一路走来陪伴我们的座右铭，十八年的风雨里程,见证着正心大药房的成长、进步与发展，在过去的十八年中，我们以优质的品种，规范的经营，热情的服务在广大的消费者中赢得了口碑，收获了友谊。",
          date: "2021-05-25",
          viewNum: 415,
        },
        {
          imgUrl: require("@/assets/news-2.png"),
          title: "春暖花开养生季 正心优嘉送礼来",
          content: "正心大药房正心币日随心购万元现金大放送",
          date: "2021-05-25",
          viewNum: 191,
        },
        {
          imgUrl: require("@/assets/news-3.jpeg"),
          title: "正心大药房【宝平店】即将盛大开业！",
          content:
            "正心大药房宝平店即将盛大开业，届时豪礼相送，不止五折，敬请期待!",
          date: "2021-05-25",
          viewNum: 515,
        },
        {
          imgUrl: require("@/assets/news-4.png"),
          title: "杏林仁心宝坻名医--------孙秀兰，坐诊正心大药房",
          content:
            "通药性，精医理，医药兼修，辩证调方，注康养，治未病，着手成春，悬壶济人，您身边的杏林仁心，宝坻名医孙秀兰。",
          date: "2021-05-25",
          viewNum: 1137,
        },
      ],
      tipsData: [
        {
          imgUrl: require("@/assets/center-1.png"),
          title: `人人都说保护心脏，多数人却不知道心脏最"怕"你干这些事`,
          content: `常听说胃癌、肝癌、肺癌、肾癌，而心脏，作为维持生命最不可缺少的器官之一，很多人都没有听说过“心脏癌”`,
        },
        {
          imgUrl: require("@/assets/center-2.png"),
          title: `万万没想到！高血压的"罪魁祸首"不是盐，竟是它…很多人都忽略了`,
          content:
            "大家都知道，食盐摄入过多容易诱发高血压，主要是因为里面的钠离子。",
        },
        {
          imgUrl: require("@/assets/center-3.png"),
          title: "人体最佳运动阶段表：到什么年纪，就做什么运动！",
          content: "世界卫生组织公布，懒得运动已经成为全球第四大死亡风险因素。",
        },
      ],
      form: {
        title: "",
        content: "",
        email: "",
        code: "",
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        code: [
          {
            required: true,
            validator: checkCode,
            trigger: "blur",
          },
        ],
      },
      captchaCode: "",
    };
  },
  methods: {
    handleClick(id) {
      // 滑动到指定id的位置
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    handleToDetail(id, type) {
      // 跳转到详情页
      this.$router.push({ path: "/detail", query: { id: id, type: type } });
    },
    handleSubmit() {
      // 验证form
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 提交表单
          this.form = {
            title: "",
            content: "",
            email: "",
            code: "",
          };
          this.refreshCaptcha();
          this.$message({
            message: "提交成功",
            type: "success",
          });
        }
      });
    },
    generateCaptcha() {
      const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";
      for (let i = 0; i < 4; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result;
    },
    refreshCaptcha() {
      this.captchaCode = this.generateCaptcha();
      console.log(this.captchaCode);
      this.drawCaptcha();
    },
    drawCaptcha() {
      const canvas = this.$refs.captchaCanvas;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      // 画背景干扰线
      ctx.strokeStyle = "#cccccc";
      for (let i = 0; i < 10; i++) {
        ctx.beginPath();
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.stroke();
      }
      // 画背景干扰点
      ctx.fillStyle = "#333333";
      for (let i = 0; i < 100; i++) {
        ctx.beginPath();
        ctx.arc(
          Math.random() * canvas.width,
          Math.random() * canvas.height,
          1,
          0,
          2 * Math.PI
        );
        ctx.fill();
      }
      // 画验证码字符
      ctx.font = "18px Arial";
      ctx.fillStyle = "#333333";
      for (let i = 0; i < this.captchaCode.length; i++) {
        const x = 15 + i * 25;
        const y = 20 + Math.random() * 10;
        ctx.fillText(this.captchaCode[i], x, y);
      }
    },
  },
  mounted() {
    this.refreshCaptcha();
  },
};
</script>

<style lang="scss" scoped>
.menu-item {
  cursor: pointer;
  padding: 20px 30px;
  &:hover {
    color: #27cbee;
    border-bottom: 3px solid #27cbee;
  }
}
.captcha {
  border: 1px solid #ccc;
  cursor: pointer;
}
</style>
